import React, { Fragment } from 'react';

export default {
  title: <Fragment>Rot-Grün</Fragment>,
  duration: 'Oktober 1998 - November 2005',
  startDate: new Date(1998, 9, 26),
  endDate: new Date(2005, 10, 21),
  description: 'Kanzlerpartei',
  description_long: 'Die Sozialdemokraten sind 1998 auf ihrem Höhepunkt - und starten mit den Grünen ein neues Regierungsprojekt, das 2005 mit vorgezogenen Neuwahlen endet. Unter Rot-Grün werden einschneidende Reformen des Sozialstaats beschlossen, Hartz-IV inklusive. Dies wird das Land nachhaltig verändern - und die SPD spalten.',
  items: [{
    milestone: true,
    coords: {
      x: new Date(1999, 2, 11),
      y: 33
    },
    coordsMobile: {
      x: new Date(1999, 2, 11),
      y: 30
    },
    kicker: '12. März 1999',
    title: (<h3>Gerhard Schröder <em>(1836 Tage)</em></h3>),
    text:
      <p>
        <span className="media">
          <img src="images/chronik/02-1999-schroeder.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption"></span>
            <span className="media-credit">picture alliance/Ulrich Baumgarten</span>
          </span>
        </span>
      Am 11. März 1998 schmeißt Oskar Lafontaine seine Ämter als Bundesfinanzminister und SPD-Chef hin. 
      Gerhard Schröder hat das innerparteiliche Duell gewonnen und wird nun auch an die Parteispitze gewählt. 
      Erstmals seit Willy Brandt liegen Parteivorsitz und Kanzleramt wieder in einer Hand. 
      Und Modernisierer Schröder hat freie Bahn für seinen Kurs der Neuen Mitte.
      </p>,
      additional: (<ul>
          <li><strong>Umfragehoch: </strong>44&nbsp;Prozent (Forsa) am 20. Januar 2000</li>
          <li><strong>Umfragetief: </strong>23&nbsp;Prozent (Forsa) am 5. November 2003</li>
        </ul>)
  },  {
    milestone: false,
    coords: {
      x: new Date(2002, 8, 21),
      y: 31
    },
    coordsMobile: {
      x: new Date(2002, 8, 21),
      y: 29
    },
    kicker: '22. September 2002',
    title: 'SPD kann nach knapper Wahl weiterregieren',
    text:
    <p>
    Trotz Rückschlägen in der ersten Amtszeit gewinnt Schröders SPD die Bundestagswahl. Vor allem das entschiedene Nein zu einem möglichen Irakkrieg rettet die Sozialdemokraten. 
    Allerdings ist das Wahlergebnis äußerst knapp: Nur 6027 Zweitstimmen trennen die SPD und die Union (38,52 zu 38,51 Prozent). 
    </p>
  }, {
    milestone: false,
    coords: {
      x: new Date(2003, 2, 13),
      y: 28
    },
    coordsMobile: {
      x: new Date(2003, 2, 13),
      y: 28
    },
    kicker: '14. März 2003',
    title: 'Schröder verkündet seine Agenda 2010',
    text:
    <p>
    In seiner Regierungserklärung umreißt Schröder sein großes Reformvorhaben, die “Agenda 2010”. 
    Dabei kündigt er umfangreiche Einschnitte in den Sozialstaat an. 
    Dafür bekommt er sogar Beifall eines FDP-Abgeordneten, setzt aber zugleich seine Partei einer Zerreißprobe aus.
    </p>
  }, {
    milestone: true,
    coords: {
      x: new Date(2004, 2, 20),
      y: 24
    },
    coordsMobile: {
      x: new Date(2004, 2, 20),
      y: 20
    },
    kicker: '21. März 2004',
    title: (<h3>Franz Müntefering <em>(604 Tage)</em></h3>),
    text:
    <p>
        <span className="media">
          <img src="images/chronik/03-2004-muentefering.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption"></span>
            <span className="media-credit">picture-alliance/Sven Simon</span>
          </span>
        </span>
        Die Agenda 2010 sorgt für bundesweite Proteste, miese Umfragewerte und heftigen Streit unter den Genossen. 
        Als SPD-Chef gelingt es Schröder nicht, die Partei zu einen. Das soll nun einer seiner engsten Mitstreiter übernehmen: Franz Müntefering. 
        Mit 95,1 Prozent wird er an die Spitze gewählt. “Das ist das schönste Amt neben dem Papst”, sagt er wenig später zum SPD-Vorsitz.
    </p>,
    additional: (<ul>
          <li><strong>Umfragehoch: </strong>35&nbsp;Prozent (Forsa) am 11. Januar 2005</li>
          <li><strong>Umfragetief: </strong>23&nbsp;Prozent (Infratest dimap) am 2. Juli 2004</li>
        </ul>)
  }, {
    coords: {
      x: new Date(2005, 8, 17),
      y: 34
    },
    coordsMobile: {
      x: new Date(2005, 8, 17),
      y: 34.2
    },
    title: 'Schröder verpokert sich mit Neuwahlen',
    kicker: '18. September 2005',
    text:
      <p>
     Mit der Vertrauensfrage im Bundestag will Schröder vorgezogene Neuwahlen. Und er bekommt sie. 
     Schröder will sich damit eigentlich seine Reformpolitik von den Bürgern bestätigen lassen. 
     Doch die stimmen mit einem Prozentpunkt mehr für CDU/CSU (35,2 Prozent). 
     Damit beginnt die Ära von Angela Merkel - auch wenn das ein vor Selbstbewusstsein strotzender Noch-Kanzler am Wahlabend nicht wahrhaben will. 
      </p>
  }, {
    coords: {
      x: new Date(2005, 10, 14),
      y: 36
    },
    coordsMobile: {
      x: new Date(2005, 10, 14),
      y: 37
    },
    milestone: true,
    kicker: '15. November 2005',
    title: (<h3>Matthias Platzeck <em>(146 Tage)</em></h3>),
    text:
      <p>
        <span className="media">
          <img src="images/chronik/04-2005-platzeck.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption"></span>
            <span className="media-credit">dpa/picture alliance</span>
          </span>
        </span>
        Kurz vor Start der ersten Groko unter Merkel muss die SPD einen neuen Chef wählen, weil Müntefering nicht mehr will. 
        Hoffnungsträger ist Brandenburgs Ministerpräsident Matthias Platzeck: Mit 99,4 Prozent erzielt er auf dem Parteitag das bis dahin beste Ergebnis. 
        Doch gesundheitliche Probleme machen ihm zu schaffen: So wird es die kürzeste Amtszeit eines gewählten SPD-Chefs.
      </p>,
    additional: (<ul>
          <li><strong>Umfragehoch: </strong>34&nbsp;Prozent (Infratest dimap) am 17. November 2005</li>
          <li><strong>Umfragetief: </strong>27&nbsp;Prozent (Forsa) am 8. März 2006</li>
        </ul>)
  }]
};
